import React from 'react';
import './Hero.css';
import { useTranslation } from 'react-i18next';

import homeVideo from '../../../assets/video/homeHeader.mp4';
import { Link } from 'react-router-dom';
import useLangLink from "../../../utils/useLangLink";
import CounterAnimation from '../../CounterAnimation/CounterAnimation';

import blackArrow from '../../../assets/images/blackArrow.svg';
import BreadCrumbs from '../../BreadCrumbs/BreadCrumbs';

function Hero({  breadcrumbs, contentCenter, pretitle, title, descr, backgroundImg, colorContent }) {
  const { t } = useTranslation();
    const lp = useLangLink();
  const ts = (k, d) => t(`sections.hero.${k}`, d);
  // пока захардкожено; при желании можно пробрасывать через пропсы
  const defaultBreadcrumbs = [
    { name: '', link: '/' },
  ];

  const crumbs = breadcrumbs && breadcrumbs.length > 0 ? breadcrumbs : defaultBreadcrumbs;

  return (
    <main className="main hero-main">
      <section className="hero-section">
        {contentCenter ? (
          // Вариант с фоновой картинкой (about, why offshore, и т.п.)
          <div className={backgroundImg || 'header-background'}>
            <div className="header-center-row">
              <div className="upper">
                <BreadCrumbs  data={crumbs} color={colorContent !== 'black'} />
              </div>

              <div className="bottom">
                <div className="header-center-content">
                  {pretitle && (
                    <span className="header-center-pre-title">
                      {pretitle}
                    </span>
                  )}

                  <h2
                    className={`header-center-title ${
                      colorContent === 'black' ? 'text-black' : ''
                    }`}
                  >
                    {title}
                  </h2>

                  {descr && (
                    <div className="header-center-description-wrapper">
                      <p
                        className={`header-center-description ${
                          colorContent === 'black' ? 'text-black' : ''
                        }`}
                      >
                        {descr}
                      </p>
                    </div>
                  )}

                  <Link
                    to={lp('/newsletter')}
                    className="header-btn-white"
                    
                    
                  >
                    <span>{ts('contactUs')}</span>
                    <div className="header-btn-img-wrapper">
                      <img src={blackArrow} alt={ts('arrowAlt')} />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ) : (
          // Главная: видео на фоне + контент
          <>
            <video
              src={homeVideo}
              className="homeVideo"
              loop
              autoPlay
              muted
              playsInline
            />

            <div className="hero-container">
              {/* Хлебные крошки под шапкой, поверх видео */}
              <div className="hero-breadcrumbs">
                <BreadCrumbs data={crumbs} color={true} />
              </div>

              <div className="hero-container-upper">
                <div className="hero-title-box">
                  <h1 className="hero-title">
                    Offshore Advisory
                  </h1>
                  <p className="sub_title_descr">{ts('subtitle')}</p>
                  <Link to={lp("/newsletter")} className="btn-white">
                    {ts('contactUs')}
                    <img src={blackArrow} />
                  </Link>
                </div>
              </div>

              <div className="hero-container-bottom">
                <div className="hero-services-block">
                  <h4>
                    <CounterAnimation end={4713} duration={2500} />
                  </h4>
                  <p className="hero-services-descr">
                    {ts('companiesServiced')}
                  </p>
                </div>
                <div className="hero-services-block">
                  <h4>
                    <CounterAnimation end={541} duration={2000} />
                  </h4>
                  <p className="hero-services-descr">
                    {ts('licensesObtained')}
                  </p>
                </div>
              </div>
            </div>
          </>
        )}
      </section>
    </main>
  );
}

export default Hero;
